import { render, staticRenderFns } from "./CardUpgradeModal.vue?vue&type=template&id=cf891032&scoped=true&"
import script from "./CardUpgradeModal.vue?vue&type=script&lang=js&"
export * from "./CardUpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./CardUpgradeModal.vue?vue&type=style&index=0&id=cf891032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf891032",
  null
  
)

export default component.exports